import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const FieldNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      placeholder="Enter field number"
      type="text"
      id="fieldNumber"
      name="fieldNumber"
      label="Field Number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default FieldNumber;
